const BREAKPOINT_TABLET = 700;
const BREAKPOINT_DESKTOP = 1280;

function pageSize() {
  const width = window.innerWidth;
  if (width >= BREAKPOINT_DESKTOP) return 8;
  if (width >= BREAKPOINT_TABLET) return 4;
  return 2;
}

function renderTimeline(container, page) {
  const track = container.querySelector(".construction-status-timeline__track");
  if (!track) return;

  const steps = [...track.querySelectorAll("[data-step]")];
  const previous = track.querySelector("[data-previous-label]");
  const upcoming = track.querySelector("[data-upcoming-label]");
  if (!steps.length || !previous || !upcoming) return;

  const size = pageSize();
  const pages = Math.max(1, Math.ceil(steps.length / size));
  const currentPage = Math.min(Math.max(page, 0), pages - 1);
  const start = currentPage * size;
  const end = start + size;
  const paginate = steps.length > size;

  container.dataset.currentPage = currentPage;

  steps.forEach((step, index) => {
    const visible = !paginate || (index >= start && index < end);
    step.hidden = !visible;
    step.classList.toggle(
      "construction-status-timeline__step--segment-start",
      visible && index === start && currentPage === 0
    );
    step.classList.toggle(
      "construction-status-timeline__step--after-previous",
      visible && index === start && currentPage > 0
    );
  });

  previous.hidden = !paginate || currentPage === 0;
  upcoming.hidden = !paginate || currentPage >= pages - 1;
}

function initTimelines() {
  document.querySelectorAll("[data-construction-status-timeline]").forEach((container) => {
    renderTimeline(container, 0);
  });
}

if (!window.constructionTimelineBound) {
  window.constructionTimelineBound = true;

  document.addEventListener("click", (event) => {
    const upcoming = event.target.closest("[data-upcoming-label]");
    if (upcoming && !upcoming.hidden) {
      event.preventDefault();
      const container = upcoming.closest("[data-construction-status-timeline]");
      renderTimeline(container, parseInt(container.dataset.currentPage, 10) + 1);
      return;
    }

    const previous = event.target.closest("[data-previous-label]");
    if (previous && !previous.hidden) {
      event.preventDefault();
      const container = previous.closest("[data-construction-status-timeline]");
      renderTimeline(container, parseInt(container.dataset.currentPage, 10) - 1);
    }
  });
}

document.addEventListener("turbolinks:load", initTimelines);
window.addEventListener("resize", initTimelines);
